// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1643":"d7be6c416530645d","2330":"f3cdbdff1d0c69cf","3100":"807660f0cd16f319","5252":"179070e78518c6ce"}[chunkId] + ".js";
};